<template>

  <v-app>
    <v-app-bar 
      app 
      color="black" 
      class ="ma-5 " 
      style="border-radius: 10px;"
      v-if="getLogeadoFitHouse"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" color="white"></v-app-bar-nav-icon>
    </v-app-bar>

    <!-- Navigation drawer -->
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      v-if="getLogeadoFitHouse"
    >
      <v-list-item align="center" class="text-center x-2">
        <v-list-item-content align="center" class="text-center">
          <v-img src="@/assets/logo.png" max-width="150"></v-img>
        </v-list-item-content>
      </v-list-item>

      <div class="mb-0 px-2 font-weight-bold colorCurso text-body-1 text-center" >
        <strong>{{ getdatosUsuarioFitHouse.nombre_completo }}</strong>
      </div>
      <v-divider></v-divider>

      <v-list nav>
        <v-list-group
          v-if="getdatosUsuarioFitHouse.tipo_usuario != 3"
          v-for="item in menu"
          :key="item.title"
          :prepend-icon="item.icon"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            color="primary"
            v-for="child in item.items"
            :key="child.title"
            :to="{ name: child.name }"
            class="pl-2"
          >

            <v-list-item-icon>
              <v-icon color="primary">mdi mdi-circle-medium theme--light</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-if="getdatosUsuarioFitHouse.tipo_usuario == 3"
          v-for="item in menu"
          :key="item.title"
          :prepend-icon="item.icon"
          no-action
          :to="{ name: item.name }"
        >

          <v-list-item-icon>
            <v-icon color="primary">mdi mdi-circle-medium theme--light</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- REGLAMENTO -->
      <v-list nav class="mr-0">
        <v-list-item :to="{ name: 'Perfil' }" class="orange white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Perfil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- REGLAMENTO -->
      <v-list nav class="mr-0">
        <v-list-item @click="salir" class="red white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-navigation-drawer>

    <v-main>
      <router-view/>
    </v-main>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-app>
</template>

<script>

  import { mapGetters, mapActions }    from "vuex";



  export default {
    name: 'App',

    data: () => ({
      drawer: false,
      mini: false,

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,
      //
    }),

    computed: {
      ...mapGetters('login',['getLogeadoFitHouse','getdatosUsuarioFitHouse']),

      menu(){

        console.log( this.getdatosUsuarioFitHouse )

        let opciones = []

        switch( this.getdatosUsuarioFitHouse.tipo_usuario ){

          case 1: 
            opciones = [
              { 
                title: "Catálogos", 
                icon: "mdi-account", 
                items:[
                  { title: "Usuarios"        , icon: "mdi-account"             , name: "Usuarios"      },
                  { title: "Paquetes"        , icon: "mdi-account"             , name: "Paquetes"      },
                  { title: "Categorías"      , icon: "mdi-account"             , name: "Categorias"    },
                ]      
              },

              { 
                title: "Administrador", 
                icon: "mdi-folder-key", 
                items:[
                  { title: "Programación"        , icon: "mdi-account"             , name: "Programacion"      },
                  { title: "Historial de pagos"  , icon: "mdi-account"             , name: "Pagos"             },
                  { title: "Calendarios"         , icon: "mdi-account"             , name: "Calendarios"       },
                ]      
              },
            ] 
          break;

          case 2:
            opciones = [
              { 
                title: "Catálogos", 
                icon: "mdi-account", 
                items:[
                  { title: "Usuarios"        , icon: "mdi-account"             , name: "Usuarios"      },
                  { title: "Paquetes"        , icon: "mdi-account"             , name: "Paquetes"      },
                  { title: "Categorías"      , icon: "mdi-account"             , name: "Categorias"    },
                ]      
              },

              { 
                title: "Administrador", 
                icon: "mdi-folder-key",
                items:[
                  { title: "Programación"        , icon: "mdi-account"             , name: "Programacion"      },
                  { title: "Historial de pagos"  , icon: "mdi-account"             , name: "HistorialPagos"    },
                  { title: "Calendarios"         , icon: "mdi-account"             , name: "Calendarios"       },
                ]      
              },
            ]
          break;

          case 3:
            opciones = [
              { title: "Paquetes"            , icon: "mdi-account"             , name: "CompraPaquetes"    },
              { title: "Historial de pagos"  , icon: "mdi-account"             , name: "HistorialPagos"    },
              { title: "Calendarios"         , icon: "mdi-account"             , name: "MiProgramacion"    }
              // { title: "Programación"        , icon: "mdi-account"             , name: "Programacion"      },
            ] 
          break; 

        }
        return opciones
      }
    },

    methods:{

      ...mapActions('login',['salirLogin']),

      salir(){
        this.salirLogin()
        this.$router.push({name:'Login'})
      },

    }
  }
</script>
<style>

  main{
    background: #f8f9fa ;
  }

  .v-navigation-drawer__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-navigation-drawer__content::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-button:increment,.v-navigation-drawer__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  html{
    background: #f8f9fa;
  }

  .v-main__wrap{
    background: #f8f9fa !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .shadowCard{
    border-radius: 8px !important; 
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.2)  !important;
  }

  .v-data-table--fixed-header > #idScrollApp::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

</style>
